import React, { FC } from 'react';
import { Destination } from 'src/common/types/api/v4/boats/search';
import UniversalLink, { UniversalLinkProps } from 'src/common/components/UniversalLink';

import Typography from 'src/common/components/Typography/index';
import { useTranslation } from 'next-i18next';
import styles from './TopDestination.module.scss';

export type DestinationSimple = Pick<Destination, 'slug' | 'breadcrumbs' | 'boat_count'>;

export type TopDestinationProps = {
  destination: DestinationSimple;
  href: UniversalLinkProps['href'];
};

/**
 * This component returns an `<li>`
 *  and should always be wrapped in a `<ul>` for accessibility
 */
const TopDestination: FC<TopDestinationProps> = (
  { destination, href },
) => {
  const [t] = useTranslation('common');
  if (!destination) {
    return null;
  }
  return (
    <li className={styles.li}>
      <UniversalLink
        href={href}
        className={styles.item}
      >
        <Typography
          size="body-l"
          type="p"
          weight="semibold"
        >
          {destination.breadcrumbs[destination.breadcrumbs.length - 1].name}
          <span>
            {destination.breadcrumbs.length > 1
                && `, ${destination.breadcrumbs[destination.breadcrumbs.length - 2].name}`}
          </span>
        </Typography>
        <div className={styles.count}>
          <Typography
            size="body-m"
            weight="regular"
            type="p"
          >
            {t('top-destination-count', { count: destination.boat_count })}
          </Typography>
        </div>
      </UniversalLink>
    </li>
  );
};

export default TopDestination;
